import styled from 'styled-components';
export var StyledModuleMediaContainer = styled.div.withConfig({
  componentId: "sc-12305dw-0"
})(["display:flex;align-items:center;justify-content:center;overflow:hidden;width:100%;height:auto;> *{width:100%;height:auto;}"]);